import React, { useEffect, useCallback } from "react";
import "./GameIFrameComponent.scss";

interface GameIFrameComponentProps {
  launchUrl: string | null;
  setGameState: (state: boolean) => void;
}

const GameIFrameComponent: React.FC<GameIFrameComponentProps> = ({
  launchUrl,
  setGameState,
}) => {
  const isMobileDevice = (): boolean =>
    /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const openGame = useCallback(
    (url: string) => {
    if (!url) return;

    if (isMobileDevice()) {
      window.location.href = url;
    } else {
      const newTab = window.open(url, "_blank");
      if (!newTab) {
        console.warn("Popup blocked! Please allow popups for this site.");
      }
    }

    setGameState(false);
    },
    [setGameState]
  );

  useEffect(() => {
    if (launchUrl) {
      openGame(launchUrl);
    }
  }, [launchUrl, openGame]);

  return null;
};

export default GameIFrameComponent;
